import React from 'react';
import { Link } from 'react-router-dom';

const overlayStyle = {
	position: 'fixed',
	inset: 0,
	background: 'rgba(17, 17, 19, 0.72)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '24px',
	zIndex: 2000,
};

const modalStyle = {
	width: 'min(520px, 100%)',
	background: '#fff',
	borderRadius: '20px',
	padding: '24px',
	boxShadow: '0 24px 80px rgba(0, 0, 0, 0.2)',
};

const buttonStyle = {
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '12px',
	padding: '12px 18px',
	background: '#111113',
	color: '#fff',
	fontWeight: 700,
	textDecoration: 'none',
	border: 'none',
	cursor: 'pointer',
};

const UpgradePrompt = ({ isOpen, detail, onClose }) => {
	if (!isOpen || !detail) return null;

	return (
		<div style={overlayStyle} role="dialog" aria-modal="true" aria-labelledby="upgrade-modal-title">
			<div style={modalStyle}>
				<h2 id="upgrade-modal-title" style={{ marginTop: 0 }}>Upgrade Required</h2>
				<p style={{ color: '#4B5563', lineHeight: 1.6 }}>
					{detail.message || 'Your current plan does not include this feature or capacity.'}
				</p>
				{detail.requiredPlan && (
					<p style={{ color: '#111113', fontWeight: 700 }}>
						Required plan: {detail.requiredPlan}
					</p>
				)}
				<div style={{ display: 'flex', gap: '12px', marginTop: '20px', flexWrap: 'wrap' }}>
					<Link to="/pricing" style={buttonStyle} onClick={onClose}>
						View Pricing
					</Link>
					<Link to="/account" style={{ ...buttonStyle, background: '#F3F4F6', color: '#111113' }} onClick={onClose}>
						Account Dashboard
					</Link>
					<button type="button" style={{ ...buttonStyle, background: '#F3F4F6', color: '#111113' }} onClick={onClose}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default UpgradePrompt;
